import React, { Component } from "react";

import { Grid, Typography } from "@material-ui/core";

import { WithStyles, createStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import _, { isEmpty } from "lodash";
import PersonIcon from "@material-ui/icons/Person";

import { MyPATCollapse, MyPATLink } from "../../common";
import ContentData from "../types/ContentData";
import MyPATTabs from "../../common/MyPATTabs";
import MyPATTab from "../../common/MyPATTab";
import classNames from "classnames";

const styles = (theme: Theme) =>
  createStyles({
    upperText: {
      fontSize: "13px",
      opacity: 0.7,
      marginBottom: "6px",
    },
    keyValueContainer: {
      marginBottom: 15,
      // "& *": {
      //   display: "block",
      //   marginRight: "4px",
      //   fontSize: 16,
      // },
    },
    clientTitle: {
      fontSize: 18,
      fontWeight: 700,
      color: "#333",
      lineHeight: "38px",
      marginBottom: 5,
      "&:last-of-type": {
        border: "none",
      },
    },
    seperator: {
      margin: "5px 10",
      borderBottom: "1px solid #b9ddca",
      color: "#000",
      backgroundColor: "#b9ddca24",
      padding: 10,
      borderRadius: 2,
    },
    seperatorBlue:{
      margin: "5px 10",
      borderBottom: "1px solid #b7cce7",
      color: "#000",
      backgroundColor: "#edf5ff",
      padding: 10,
      borderRadius: 2,
    },
    spaceBelow: {
      marginBottom: "13px",
    },
    spaceRight: {
      marginRight: "13px",
    },
		spaceTop: {
			marginTop: '13px'
		},
    sharedTabContainer:{

    }
  });

//@ts-ignore
interface SharedContentWithProps extends WithStyles<typeof styles> {
  classes: any;
  content: ContentData;
}

type ShareType = "Clients" | "Users";

interface SharedContentWithStates {
  showFullEdit: boolean;
  showFullView: boolean;
  shareType: ShareType;
}

class SharedContentWith extends Component<
  SharedContentWithProps,
  SharedContentWithStates
> {
  constructor(props: SharedContentWithProps, state: SharedContentWithStates) {
    super(props);
    this.state = {
      showFullEdit: false,
      showFullView: false,
      shareType: "Clients",
    };
    this.toggleTextEdit = this.toggleTextEdit.bind(this);
    this.toggleTextView = this.toggleTextView.bind(this);
  }

  handleActiveTabChange = (eventKey: ShareType) => {
    this.setState({
      shareType: eventKey,
    });
  };

  toggleTextEdit() {
    this.setState({ showFullEdit: !this.state.showFullEdit });
  }

  toggleTextView() {
    this.setState({ showFullView: !this.state.showFullView });
  }

  getTabBasedData = () => {
    const { content } = this.props;
    const { shareType } = this.state;
    let sharedWith = _.get(content, "aclMetaData.allowedTo", []);
    let sharedWithEdit: any = sharedWith.filter((s: any) =>
      s.accessAllowed.includes("EDIT")
    );
    let sharedWithView: any = sharedWith.filter(
      (s: any) =>
        !s.accessAllowed.includes("EDIT") && s.accessAllowed.includes("VIEW")
    );

    sharedWithEdit = sharedWithEdit.filter(({ clientId }: any) =>
      shareType === "Users" ? !clientId : !!clientId
    );
    sharedWithView = sharedWithView.filter(({ clientId }: any) =>
      shareType === "Users" ? !clientId : !!clientId
    );

    if (shareType === "Users") {
      // group data by primary client
      sharedWithEdit = _.groupBy(sharedWithEdit, ({ user }: any) => {
        const clients = _.get(user, "id.clients", []);
        const primaryClient = clients.find((client: any) => client.primary);
        return _.get(primaryClient, "name", "");
      });

      sharedWithView = _.groupBy(sharedWithView, ({ user }: any) => {
        const clients = _.get(user, "id.clients", []);
        const primaryClient = clients.find((client: any) => client.primary);
        return _.get(primaryClient, "name", "");
      });
    }

    return { sharedWithEdit, sharedWithView };
  };

  renderClientSharedData = (sharedWithEdit: any, sharedWithView: any) => {
    const { classes } = this.props;

    let halfSharedView = "";
    let fullSharedView = "";
    if (sharedWithView.length) {
      sharedWithView.forEach((s: any, i: number) => {
        if (i < 5) {
          halfSharedView += _.get(s, "clientId.name", "") + ", ";
        }
        fullSharedView += _.get(s, "clientId.name", "") + ", ";
      });
    }
    return (
      <div>
        {_.isEmpty(sharedWithEdit) && _.isEmpty(sharedWithView) && (
          <Typography>
            This content is not shared with any client yet.
          </Typography>
        )}
        {!_.isEmpty(sharedWithEdit) && (
          <Typography variant="subtitle2" className={classes.upperText}>
            Edit Permission
          </Typography>
        )}

        {sharedWithEdit.map((client: any, index: number) => {
          return (
            <div className={classes.keyValueContainer}>
              <Typography
                className={classNames(classes.clientTitle, classes.seperator)}
                variant="body1"
              >
                {_.get(client, "clientId.name", "")}
              </Typography>
              <Typography variant="body1">
                {client.sectionWiseAccess[0].sections
                  .map(
                    (value: any) =>
                      value.module.charAt(0).toUpperCase() +
                      value.module.slice(1)
                  )
                  .join(", ")}
              </Typography>
            </div>
          );
        })}
        <br />

        {!_.isEmpty(sharedWithView) && (
          <>
            <Typography variant="subtitle2" className={classes.upperText}>
              View Only Permission
            </Typography>
            <div className={[classes.keyValueContainer, classes.seperatorBlue].join(' ')}>
              <Typography className={classes.clientTitle} variant="body1">
                {this.state.showFullView ? fullSharedView : halfSharedView}
              </Typography>
              {sharedWithView.length > 5 && !this.state.showFullView && (
                <Typography
                  variant="body1"
                  onClick={this.toggleTextView}
                  style={{
                    marginLeft: "10px",
                    opacity: 0.6,
                    cursor: "pointer",
                  }}
                >
                  {sharedWithView.length - 5} more
                </Typography>
              )}
              {sharedWithView.length > 5 && this.state.showFullView && (
                <Typography
                  variant="body1"
                  onClick={this.toggleTextView}
                  style={{
                    marginLeft: "10px",
                    opacity: 0.6,
                    cursor: "pointer",
                  }}
                >
                  less
                </Typography>
              )}
            </div>
          </>
        )}
        {/* </MyPATCollapse> */}
      </div>
    );
  };

  renderUserSharedDataCard = (
    clientName: string,
    data: any[],
    showSectionWiseAccess: boolean
  ) => {
    const { classes,content } = this.props;
    
    let requiredModule="studyMaterial";
    if(content.contentTypeCode=="testpapers"){
      requiredModule="test";
    }else if(content.contentTypeCode=="question"){
      requiredModule="question"; 
    }
    
   const sectionContent=_.get(data, '[0].sectionWiseAccess', []).filter((s:any)=>{
     return s.module==requiredModule;
   }); 
  return (
    <div className={classes.keyValueContainer} key={clientName}>
      <Typography className={classes.clientTitle} variant="body1">
        {clientName}
      </Typography>
      <div className={classNames(showSectionWiseAccess && classes.seperator)}>
        <span className={classes.spaceRight}>
          <PersonIcon fontSize="small" />
        </span>
        <Typography gutterBottom inline>
          {data.map(({ user }: any) => _.get(user, "name", _.get(user, 'id.fullName', ''))).join(", ")}
        </Typography>
      </div>
      {showSectionWiseAccess && (
        <Typography variant="body1" className={classes.spaceTop}>
          {
            _.get(sectionContent,"[0]sections",[]).map(
              (value: any) =>
                value.module.charAt(0).toUpperCase() + value.module.slice(1)
            )
            .join(", ")}
        </Typography>
      )}
    </div>
  );
  };

  renderUserSharedData = (sharedWithEdit: any, sharedWithView: any) => {
    const { classes } = this.props;
    return (
      <div>
        {_.isEmpty(sharedWithEdit) && _.isEmpty(sharedWithView) && (
          <Typography>
            This content is not shared with any specific user yet.
          </Typography>
        )}
        {!_.isEmpty(sharedWithEdit) && (
          <Typography variant="subtitle2" className={classes.upperText}>
            Edit Permission
          </Typography>
        )}

        {Object.entries(sharedWithEdit).map(
          ([clientName, data]: [string, any], index: number) => {
            return this.renderUserSharedDataCard(clientName, data, true);
          }
        )}
        <br />

        {!_.isEmpty(sharedWithView) && (
          <Typography variant="subtitle2" className={classes.upperText}>
            View Only Permission
          </Typography>
        )}
        {Object.entries(sharedWithView).map(
          ([clientName, data]: [string, any], index: number) => {
            return this.renderUserSharedDataCard(clientName, data, false);
          }
        )}
        {/* <div className={classes.keyValueContainer}>
          <Typography className={classes.clientTitle} variant="body1">
            {this.state.showFullView ? fullSharedView : halfSharedView}
          </Typography>
          {sharedWithView.length > 5 && !this.state.showFullView && (
            <Typography
              variant="body1"
              onClick={this.toggleTextView}
              style={{
                marginLeft: "10px",
                opacity: 0.6,
                cursor: "pointer",
              }}
            >
              {sharedWithView.length - 5} more
            </Typography>
          )}
          {sharedWithView.length > 5 && this.state.showFullView && (
            <Typography
              variant="body1"
              onClick={this.toggleTextView}
              style={{
                marginLeft: "10px",
                opacity: 0.6,
                cursor: "pointer",
              }}
            >
              less
            </Typography>
          )}
        </div> */}
        {/* </MyPATCollapse> */}
      </div>
    );
  };

  render() {
    const { classes, content } = this.props;
    const { showFullEdit, showFullView, shareType } = this.state;

    const { sharedWithEdit, sharedWithView } = this.getTabBasedData();
    let sharedWith = _.get(content, "aclMetaData.allowedTo", []);

    return (
      !_.isEmpty(sharedWith) && (
        <>
          <Grid container className={classes.sharedTabContainer}>
            <MyPATTabs
              activeTab={shareType}
              handleActiveTabChange={this.handleActiveTabChange}
            >
              <MyPATTab isCustomCSS={true} borderBottom="2px solid #1d7dea" customColor="#1d7dea" eventKey="Clients" />
              <MyPATTab isCustomCSS={true} borderBottom="2px solid #1d7dea" customColor="#1d7dea" eventKey="Users" />
            </MyPATTabs>
          </Grid>
          {shareType === "Clients"
            ? this.renderClientSharedData(sharedWithEdit, sharedWithView)
            : this.renderUserSharedData(sharedWithEdit, sharedWithView)}
        </>
      )
    );
  }
}

// @ts-ignore
export default withStyles(styles)(SharedContentWith);
